/*
  IconButton.jsx

  Meant to replicate the MUI IconButton:
  https://mui.com/material-ui/react-button/#icon-button
*/

// Npm.
import React, { useMemo } from 'react';

// Makes.
import { makeStyles, cx } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    outline: '0px',
    border: '0px none',
    margin: '0px',
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    appearance: 'none',
    textDecoration: 'none',
    textAlign: 'center',
    flex: '0 0 auto',
    fontSize: '1.5rem',
    padding: '8px',
    borderRadius: '50%',
    overflow: 'visible',
    color: theme.color_text_secondary,
    transition: 'background-color 0.1s ease',
    '&.small': {
      padding: 0,
    },
    '&:focus-visible': {
      backgroundColor: theme.action_hover,
    },
    '&:hover': {
      backgroundColor: theme.action_hover,
    },
    '&:disabled': {
      color: theme.action_disabled,
      backgroundColor: 'transparent',
      cursor: 'inherit',
    },
  }
}));

/**
 * Icon button component.
 */
export default function IconButton({ className, size, ...rest }) {

  let rootClass = 'IconButton';

  if (size === 'small') {
    rootClass += ` ${size}`;
  }

  const classes = useStyles();
  const cls = useMemo(() => cx(rootClass, classes.root, className), [rootClass, classes.root, className]);

  return (
    <button
      className={cls}
      type="button"
      {...rest}
    />
  );
}
